import { useAuthState } from '@creditornot/wolt-auth/react';
import { stringify } from 'query-string';
import { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { searchStringToObject, StringParam, useQueryParam } from 'use-query-params';

import { useLocalStorage } from 'common/hooks';

/** Extracts the next page from the query params and saves it to local storage.
 * If the user is logged in, the next page is removed from local storage.
 * Returns the next page from local storage.
 **/
export function useNextPage() {
  const { user } = useAuthState();
  const [nextQueryParam] = useQueryParam('next', StringParam);
  const { search: searchParamsString } = useLocation();
  const restQueryParams = useMemo(() => {
    const { next: _, ...restQueryParams } = searchStringToObject(searchParamsString);
    return restQueryParams;
  }, [searchParamsString]);

  const nextRedirectUrl = `${nextQueryParam}?${stringify(restQueryParams)}`;
  const [nextFromLocalStorage, saveNextToLocalStorage] = useLocalStorage(
    'next',
    !!nextQueryParam ? nextRedirectUrl : '',
  );

  useEffect(() => {
    if (!!nextQueryParam && nextQueryParam !== '/') {
      saveNextToLocalStorage(nextRedirectUrl);
    }
  }, [nextQueryParam, nextRedirectUrl, saveNextToLocalStorage]);

  useEffect(() => {
    if (!!user) {
      localStorage.removeItem('next');
    }
  }, [user]);

  return { nextPage: nextFromLocalStorage };
}
